import type { Grade } from '@strategy4kids/lessons';
import { Star } from 'lucide-react';

const FILLED: Record<Grade, number> = { gold: 3, silver: 2, bronze: 1 };

export function ProgressStars({ grade, size = 28 }: { grade: Grade | null; size?: number }) {
  const filled = grade ? FILLED[grade] : 0;
  return (
    <div className="flex items-center gap-0.5" data-testid="progress-stars">
      {[0, 1, 2].map((i) => (
        <Star
          key={i}
          size={size}
          data-testid={i < filled ? 'star-filled' : 'star-empty'}
          className={i < filled ? 'fill-sun text-sun' : 'fill-cream text-ink/20'}
        />
      ))}
    </div>
  );
}
